import { render, staticRenderFns } from "./tour2egg6.vue?vue&type=template&id=01a8a45e&scoped=true&"
import script from "./tour2egg6.vue?vue&type=script&lang=js&"
export * from "./tour2egg6.vue?vue&type=script&lang=js&"
import style0 from "./tour2egg6.vue?vue&type=style&index=0&id=01a8a45e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8a45e",
  null
  
)

export default component.exports